import {
    ExtendedApiObject,
    findApartmentBuilding,
    findConstructionNumber,
    findProjectPhase,
    findPropertyType,
} from '../../api-utilities';
import { ExtendedAreaModels } from '../extended-area';

/**
 * @description Finds and returns the extended API Object with the set id.
 * @param {ExtendedAreaModels} { constructionNumbers, propertyTypes, apartmentBuildings, projectPhases }
 * @param {string} id
 * @return {*}  {(ExtendedApiObject | undefined)}
 */
const findExtendedObjectById = (
    {
        areaProject,
        constructionNumbers,
        propertyTypes,
        apartmentBuildings,
        projectPhases,
        districts,
    }: ExtendedAreaModels,
    id: string,
): ExtendedApiObject | undefined => {
    if (areaProject.id === id) return areaProject;

    const constructionNumber = findConstructionNumber(constructionNumbers, { id });
    if (constructionNumber) return constructionNumber;

    const propertyType = findPropertyType(propertyTypes, { id });
    if (propertyType) return propertyType;

    const apartmentBuilding = findApartmentBuilding(apartmentBuildings, { id });
    if (apartmentBuilding) return apartmentBuilding;

    const projectPhase = findProjectPhase(projectPhases, { id });
    if (projectPhase) return projectPhase;

    const district = districts.find((district) => district.id === id);
    if (district) return district;

    return;
};

export { findExtendedObjectById };
